import React from 'react';
import { HomeOutlined, InfoCircleOutlined, CustomerServiceOutlined, DollarOutlined, ShoppingOutlined, FireOutlined, UnorderedListOutlined, QuestionCircleOutlined, FileTextOutlined, SafetyOutlined, StarOutlined, TagsOutlined, AppstoreOutlined, ThunderboltOutlined, GlobalOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const Sitemap = () => {
  const sitemapSections = [
    {
      title: 'Main Pages',
      icon: <HomeOutlined />,
      color: '#0d6efd',
      gradient: 'linear-gradient(135deg, rgb(13, 110, 253) 0%, rgb(0, 80, 179) 100%)',
      links: [
        { path: '/', label: 'Home', icon: <HomeOutlined /> },
      ],
    },
    {
      title: 'Auctions',
      icon: <ShoppingOutlined />,
      color: '#1890ff',
      gradient: 'linear-gradient(135deg, #1890ff 0%, #0050b3 100%)',
      links: [
        { path: '/auctions', label: 'All Auctions', icon: <AppstoreOutlined /> },
        { path: '/live-auctions', label: 'Live Auctions', icon: <ThunderboltOutlined /> },
        { path: '/featured-auctions', label: 'Featured Auctions', icon: <FireOutlined /> },
      ],
    },
    {
      title: 'Lots',
      icon: <UnorderedListOutlined />,
      color: '#52c41a',
      gradient: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
      links: [
        { path: '/browse-lots', label: 'All Lots', icon: <TagsOutlined /> },
        { path: '/featured-lots', label: 'Featured Lots', icon: <FireOutlined /> },
      ],
    },
    {
      title: 'Categories',
      icon: <GlobalOutlined />,
      color: '#fa541c',
      gradient: 'linear-gradient(135deg, #fa541c 0%, #d4380d 100%)',
      links: [
        { path: '/category-results', label: 'Browse Categories', icon: <GlobalOutlined /> },
      ],
    },
    {
      title: 'Information',
      icon: <InfoCircleOutlined />,
      color: '#722ed1',
      gradient: 'linear-gradient(135deg, #722ed1 0%, #531dab 100%)',
      links: [
        { path: '/about', label: 'About Us', icon: <InfoCircleOutlined /> },
        { path: '/pricing', label: 'Pricing', icon: <DollarOutlined /> },
        { path: '/how-it-works', label: 'How It Works', icon: <QuestionCircleOutlined /> },
        { path: '/faq', label: 'FAQ', icon: <QuestionCircleOutlined /> },
        { path: '/terms-and-conditions', label: 'Terms and Conditions', icon: <FileTextOutlined /> },
        { path: '/privacy-policy', label: 'Privacy Policy', icon: <SafetyOutlined /> },
      ],
    },
    {
      title: 'Support',
      icon: <CustomerServiceOutlined />,
      color: '#fa8c16',
      gradient: 'linear-gradient(135deg, #fa8c16 0%, #d46b08 100%)',
      links: [
        { path: '/feedback', label: 'Feedback', icon: <CustomerServiceOutlined /> },
        { path: '/disputes', label: 'Disputes', icon: <SafetyOutlined /> },
      ],
    },
  ];

  return (
    <div className="container py-5 sitemap-page">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-11 col-xl-10">
          {/* Header Section */}
          <div className="text-center mb-5">
            <div 
              className="d-inline-flex align-items-center justify-content-center mb-4 sitemap-header-icon"
              style={{
                width: '90px',
                height: '90px',
                borderRadius: '24px',
                background: 'linear-gradient(135deg, rgb(13, 110, 253) 0%, rgb(0, 80, 179) 100%)',
                boxShadow: '0 8px 24px rgba(13, 110, 253, 0.3)'
              }}
            >
              <HomeOutlined className="sitemap-header-icon-svg" style={{ fontSize: '45px', color: '#fff' }} />
            </div>
            <h1 
              className="display-4 fw-bold mb-3 sitemap-main-title"
              style={{
                background: 'linear-gradient(135deg, rgb(13, 110, 253) 0%, rgb(0, 80, 179) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              Sitemap
            </h1>
            <p className="lead text-muted mx-auto sitemap-description" style={{ maxWidth: '600px' }}>
              Navigate through all the pages and sections of our auction platform. Find what you're looking for quickly and easily.
            </p>
          </div>

          {/* Sitemap Sections */}
          <div className="row g-4">
            {sitemapSections.map((section, index) => (
              <div key={index} className="col-12 col-md-6 col-lg-4">
                <div 
                  className="card border-0 shadow-lg h-100 position-relative overflow-hidden sitemap-card"
                  style={{
                    borderRadius: '20px',
                    transition: 'all 0.3s ease',
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)';
                  }}
                >
                  <div 
                    className="position-absolute top-0 start-0 w-100"
                    style={{
                      height: '5px',
                      background: section.gradient
                    }}
                  />
                  <div className="card-body p-4 p-md-5 sitemap-card-body">
                    <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start gap-3 mb-4 sitemap-card-header">
                      <div
                        className="d-flex align-items-center justify-content-center flex-shrink-0 sitemap-section-icon"
                        style={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '14px',
                          background: section.gradient,
                          boxShadow: `0 4px 12px ${section.color}30`,
                          color: '#fff',
                          fontSize: '28px'
                        }}
                      >
                        {section.icon}
                      </div>
                      <h3 className="fw-bold mb-0 text-center text-md-start sitemap-section-title" style={{ color: '#212529', fontSize: '1.5rem' }}>
                        {section.title}
                      </h3>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      {section.links.map((link, linkIndex) => (
                        <Link 
                          key={linkIndex} 
                          to={link.path}
                          className="text-decoration-none d-flex align-items-center gap-3 p-3 rounded-3 sitemap-link"
                          style={{ 
                            color: '#495057',
                            transition: 'all 0.2s ease',
                            background: 'transparent'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = `${section.color}10`;
                            e.currentTarget.style.color = section.color;
                            e.currentTarget.style.transform = 'translateX(5px)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                            e.currentTarget.style.color = '#495057';
                            e.currentTarget.style.transform = 'translateX(0)';
                          }}
                        >
                          <span className="sitemap-link-icon" style={{ color: section.color, fontSize: '18px', flexShrink: 0 }}>
                            {link.icon}
                          </span>
                          <span className="fw-medium sitemap-link-label" style={{ fontSize: '1rem' }}>
                            {link.label}
                          </span>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        /* Responsive Styles */
        .sitemap-page {
          padding-top: 20px !important;
          padding-bottom: 40px !important;
        }

        /* Header Section - Mobile */
        .sitemap-header-icon {
          width: 70px !important;
          height: 70px !important;
        }

        .sitemap-header-icon-svg {
          font-size: 35px !important;
        }

        .sitemap-main-title {
          font-size: 2rem !important;
        }

        .sitemap-description {
          font-size: 1rem !important;
          padding: 0 15px;
        }

        /* Cards - Mobile */
        .sitemap-card {
          margin-bottom: 1rem;
        }

        .sitemap-card-body {
          padding: 24px !important;
        }

        .sitemap-card-header {
          flex-direction: column !important;
          align-items: center !important;
          text-align: center !important;
        }

        .sitemap-section-icon {
          margin: 0 auto !important;
          width: 48px !important;
          height: 48px !important;
          font-size: 24px !important;
        }

        .sitemap-section-title {
          font-size: 1.3rem !important;
          text-align: center !important;
          width: 100% !important;
          display: block !important;
          margin: 0 auto !important;
        }

        .sitemap-link {
          padding: 12px 16px !important;
        }

        .sitemap-link-icon {
          font-size: 16px !important;
        }

        .sitemap-link-label {
          font-size: 0.9rem !important;
        }

        /* Tablet and up */
        @media (min-width: 768px) {
          .sitemap-page {
            padding-top: 40px !important;
            padding-bottom: 60px !important;
          }

          .sitemap-header-icon {
            width: 90px !important;
            height: 90px !important;
          }

          .sitemap-header-icon-svg {
            font-size: 45px !important;
          }

          .sitemap-main-title {
            font-size: 2.5rem !important;
          }

          .sitemap-description {
            font-size: 1.1rem !important;
            padding: 0;
          }

          .sitemap-card-body {
            padding: 32px !important;
          }

          .sitemap-card-header {
            flex-direction: row !important;
            align-items: flex-start !important;
          }

          .sitemap-section-icon {
            margin: 0 !important;
            width: 56px !important;
            height: 56px !important;
            font-size: 28px !important;
          }

          .sitemap-section-title {
            font-size: 1.5rem !important;
            text-align: left !important;
          }

          .sitemap-link {
            padding: 16px 20px !important;
          }

          .sitemap-link-icon {
            font-size: 18px !important;
          }

          .sitemap-link-label {
            font-size: 1rem !important;
          }
        }

        /* Desktop and up */
        @media (min-width: 992px) {
          .sitemap-main-title {
            font-size: 3rem !important;
          }

          .sitemap-description {
            font-size: 1.2rem !important;
          }

          .sitemap-card-body {
            padding: 40px !important;
          }
        }

        /* Extra small devices */
        @media (max-width: 575px) {
          .sitemap-page {
            padding-top: 15px !important;
            padding-bottom: 30px !important;
          }

          .sitemap-header-icon {
            width: 60px !important;
            height: 60px !important;
          }

          .sitemap-header-icon-svg {
            font-size: 30px !important;
          }

          .sitemap-main-title {
            font-size: 1.75rem !important;
          }

          .sitemap-description {
            font-size: 0.9rem !important;
            padding: 0 10px;
          }

          .sitemap-card-body {
            padding: 20px !important;
          }

          .sitemap-section-icon {
            width: 44px !important;
            height: 44px !important;
            font-size: 22px !important;
          }

          .sitemap-section-title {
            font-size: 1.2rem !important;
            text-align: center !important;
            width: 100% !important;
            display: block !important;
            margin: 0 auto !important;
          }

          .sitemap-link {
            padding: 10px 12px !important;
          }

          .sitemap-link-icon {
            font-size: 16px !important;
          }

          .sitemap-link-label {
            font-size: 0.85rem !important;
          }
        }

        /* Small devices (landscape phones) */
        @media (min-width: 576px) and (max-width: 767px) {
          .sitemap-card-header {
            flex-direction: row !important;
            align-items: flex-start !important;
          }

          .sitemap-section-icon {
            margin: 0 !important;
          }

          .sitemap-section-title {
            text-align: left !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Sitemap;
